// Resolves once the browser has painted a frame (or after 50 ms, e.g. in a
// background tab, where frames don't run)
export default function afterNextPaint() {
  if (typeof requestAnimationFrame !== "function") return Promise.resolve()
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, 50)
    requestAnimationFrame(() =>
      setTimeout(() => {
        clearTimeout(timeout)
        resolve()
      }, 0),
    )
  })
}
